import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PersonalInfoSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  isCollapsed, 
  onToggleCollapse 
}) => {
  const genderOptions = [
    { value: 'M', label: 'Male' },
    { value: 'F', label: 'Female' },
    { value: 'O', label: 'Other' }
  ];

  const bloodGroupOptions = [
    { value: 'A+', label: 'A+' },
    { value: 'A-', label: 'A-' },
    { value: 'B+', label: 'B+' },
    { value: 'B-', label: 'B-' },
    { value: 'AB+', label: 'AB+' },
    { value: 'AB-', label: 'AB-' },
    { value: 'O+', label: 'O+' },
    { value: 'O-', label: 'O-' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm mb-6">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="User" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground">
              Personal Information
            </h3>
            <p className="text-sm text-muted-foreground">
              Basic personal details and contact information
            </p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-muted-foreground" 
        />
      </div>

      {!isCollapsed && (
        <div className="p-6 pt-6 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Full Name"
              type="text"
              placeholder="Enter full name"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              error={errors.name}
              required
            />

            <Select
              label="Gender"
              placeholder="Select gender"
              options={genderOptions}
              value={formData.gender}
              onChange={(value) => handleInputChange('gender', value)}
              error={errors.gender}
              required
            />

            <Input
              label="Date of Birth"
              type="date"
              value={formData.dob}
              onChange={(e) => handleInputChange('dob', e.target.value)}
              error={errors.dob}
              required
            />

            <Select
              label="Blood Group"
              placeholder="Select blood group"
              options={bloodGroupOptions}
              value={formData.bloodGroup}
              onChange={(value) => handleInputChange('bloodGroup', value)}
              error={errors.bloodGroup}
            />

            <Input
              label="Mobile Number"
              type="tel"
              placeholder="Enter mobile number"
              value={formData.mobNoPrimary}
              onChange={(e) => handleInputChange('mobNoPrimary', e.target.value)}
              error={errors.mobNoPrimary}
              required
            />

            <Input
              label="Alternate Number"
              type="tel"
              placeholder="Enter alternate number"
              value={formData.mobNoSecondry}
              onChange={(e) => handleInputChange('mobNoSecondry', e.target.value)}
              error={errors.mobNoSecondry}
            />

              <Input
              label="Aadhar Number"
              type="tel"
              placeholder="Enter Aadhar number"
              value={formData.aadharNo}
              onChange={(e) => handleInputChange('aadharNo', e.target.value)}
              error={errors.aadharNo}
            />          

            
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalInfoSection;